import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import Universities from "../../../Components/Universities";
import AssignmentList from "../../../Components/AssignmentList";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const SpeechWriting = () => {
  const subCategoryId = "6586d937d2f7eeadeea4faf5";
  const categoryId = "65524e633c005ef3b51907c9";

  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };


  const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Assignment Help"},
    { label: "Do My Proposal Writing", }
  ]
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
       <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection/>
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Benefits of DoubtQ Proposal Writing Services"
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <AssignmentList subCategoryId={subCategoryId} 
      title="Recently Completed Proposal Writing Samples" 
      description="Explore high-quality proposal samples completed by experts for students" />
      <HelpSteps subCategoryId={subCategoryId}
       description="Get your Proposal Writing support in 4 easy steps"/>
      <Milestonerewards categoryId={categoryId} description="Designed to deliver quality, accuracy, and convenience for every student"/>
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts 
      title="Meet our Proposal Writing Experts"
      description="Our professionals deliver high-quality essays with an improved writing experience"
      />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps:1,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default SpeechWriting;
